import React, { ReactElement } from 'react';
import { Button } from '../../../components/Buttons/Button/Button';

import './styles.scss';

export const PaymentFailureBanner = ({
  onClick,
}: {
  onClick: () => void;
}): ReactElement => {
  return (
    <div className="payment-failure-banner">
      <div>
        There was a problem processing your payment. Please check your payment
        details.
      </div>
      <Button
        label="Manage Subscriptions"
        colour="cta-pink"
        onClick={onClick}
      />
    </div>
  );
};
